Wee.fn.make('about', {
	init: function() {
		Wee.carousel.init({
			elementRef: 'thumb',
			arrows: 'arrow'
		});
	},
	unload: function() {
		Wee.carousel.unload();
		$.events.off(false, '.carousel');
	}
});